import React, { useCallback, useEffect, useMemo, useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Button from 'Components/button'
export interface CommunitySelectorStates {
  type: '1' | '2'
  form: {
    brand_id: string
    query: string
    series_id: string
  }
  params: {
    series_id: string
    motor_id: string
    motor_name: string
  }
}
interface ICommunitySelector {
  onCommunityTypeChange: (v: '1' | '2') => void
  onBrandChange: (v: string | null) => void
  onCommunityChange: (v: string | null) => void
  brandList: any[]
  carFansOptions: any[]
  onCancel: () => void
  onConfirm: () => void
  communityValue: string | undefined
  states: CommunitySelectorStates
  defaultCommunity?: {
    series_id: string
    series_name: string
  }
}
//const { Option } = Select
export default function CommunitySelector(props: ICommunitySelector) {
  const {
    onCommunityTypeChange,
    onBrandChange,
    onCommunityChange,
    communityValue,
    onCancel,
    onConfirm,
    states,
    brandList,
    carFansOptions,
  } = props
  const {
    type,
    form: { brand_id, query },
    params: { series_id, motor_id, motor_name },
  } = states
  const [brandInputValue, setBrandInputValue] = useState('')
  const [communityInputValue, setCommunityInputValue] = useState('')
  const brand_value = useMemo(() => {
    const the_brand = brandList?.find(
      e => e?.info?.brand_id === Number(brand_id)
    )
    const { brand_name, brand_id: bid } = the_brand?.info || {}
    if (brand_name && bid) {
      return `${brand_name}_${bid}`
    }
  }, [brandList, brand_id])

  useEffect(() => {
    if (!communityValue) {
      setCommunityInputValue('')
      return
    }
    setCommunityInputValue(communityValue.split('_')[0])
  }, [communityValue])
  useEffect(() => {
    if (!brand_value) {
      setBrandInputValue('')
      return
    }
    setBrandInputValue(brand_value.split('_')[0])
  }, [brand_value])

  const brandOptions = useMemo(() => {
    return brandList
      .filter(item => !!item.info?.brand_id)
      .map(item => `${item.info.brand_name}_${item.info.brand_id}`)
  }, [brandList])

  const renderBrands = useCallback((option: string) => {
    const name = option?.split('_')
    if (name) {
      name.splice(-1)
    }
    return name?.join('')
  }, [])

  const communityOptions = useMemo(() => {
    return carFansOptions.map(
      ({ motor_id, name, series_id }) => `${name}_${series_id}_${motor_id}`
    )
  }, [carFansOptions])

  const renderCommunities = useCallback((option: string) => {
    const name = option?.split('_')
    if (name) {
      name.splice(-2)
    }
    return name?.join('')
  }, [])
  return (
    <>
      <div className="community-select">
        <div className="select-item">
          <div className="select-name">选择圈子</div>
          <Autocomplete
            disableClearable={true}
            value={type}
            className="selector"
            onChange={(e, value) => onCommunityTypeChange(value as '1' | '2')}
            options={['1', '2']}
            getOptionLabel={option => {
              switch (option) {
              case '1':
                return '车系圈子'

              case '2':
                return '其他圈子'

              default:
                return ''
              }
            }}
            renderOption={option => {
              switch (option) {
              case '1':
                return '车系圈子'

              case '2':
                return '其他圈子'

              default:
                return ''
              }
            }}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                className="selector-input"
              />
            )}
          />
        </div>
        {type === '1' && (
          <div className="select-item">
            <div className={`select-name`}>选择品牌</div>
            <Autocomplete
              disableClearable={true}
              value={brand_value}
              inputValue={brandInputValue}
              className="selector"
              onChange={(e, value) => {
                onBrandChange(value)
              }}
              onInputChange={(e, value) => {
                setBrandInputValue(value)
              }}
              options={brandOptions}
              getOptionLabel={renderBrands}
              renderOption={renderBrands}
              renderInput={params => (
                <TextField
                  {...params}
                  variant="outlined"
                  className={`selector-input`}
                />
              )}
            />
          </div>
        )}
        <div className="select-item">
          <div className="select-name">选择车友圈</div>
          <Autocomplete
            disableClearable={true}
            value={communityValue}
            className="selector"
            onChange={(e, value) => {
              onCommunityChange(value)
            }}
            onInputChange={(e, value) => {
              setCommunityInputValue(value)
            }}
            inputValue={communityInputValue}
            options={communityOptions}
            getOptionLabel={renderCommunities}
            renderOption={renderCommunities}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                className="selector-input"
              />
            )}
          />
        </div>
        <div className="bottom-btn">
          <Button className="cancel-btn" type="default" onClick={onCancel}>
            清空
          </Button>
          <Button
            className="confirm-btn"
            type="new_primary"
            onClick={onConfirm}
          >
            确认
          </Button>
        </div>
      </div>
      <style jsx>
        {`
          .community-select {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          }

          .select-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 14px;
            margin-top: 20px;
            color: #1f2129;
          }
          .select-item:hover {
            background-color: #f2f4fa;
          }
          .select-name {
            text-align: left;
            width: 70px;
            white-space: nowrap;
            margin-right: 10px;
            font-size: 14px;
            line-height: 20px;
            font-family: 'PingFangSC-Regular';
            color: #1f2129;
          }
          :global(.selector-input > div) {
            padding: 0 !important;
          }
          :global(.selector .selector-input input) {
            width: 260px;
            height: 36px;
            padding: 8px 16px !important;
            box-sizing: border-box;
            color: #1f2129;
            font-size: 14px;
            line-height: 20px;
          }

          :global(.Mui-focused .MuiOutlinedInput-notchedOutline) {
            border-color: rgba(0, 0, 0, 0.87) !important;
            border-width: 1px !important;
          }
          :global(.MuiAutocomplete-option[data-focus='true'], .MuiAutocomplete-option[aria-selected='true']) {
            background-color: #f2f4fa;
          }
          :global(.MuiAutocomplete-option) {
            color: #1f2129;
            font-size: 14px;
            line-height: 20px;
          }
          .bottom-btn {
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
          }
          :global(.bottom-btn .cancel-btn) {
            font-weight: normal;
            border: 1px solid #c9cbd6;
          }

          :global(.bottom-btn .confirm-btn) {
            margin-left: 8px;
            font-weight: normal;
          }
        `}
      </style>
    </>
  )
}
